<template>
    <div>
        <div v-if="fetching" class="d-flex align-center">
            <div>Cargando...</div>
        </div>
        <template v-else>
            <v-card
                outlined
                class="pa-1" 
                v-for="(reporte, index) in computedList"
                :key="`summary-divisa-${index}-${reporte.divisa_id}`"
                :class="{'mt-1': index > 0}"
                >
                <template v-if="computedList.length > 1">
                    <div class="pa-1 text-overline line-height-1">{{ reporte.divisa }}</div>
                </template>
                <div class="d-flex flex-wrap">
                    <v-card elevation="0" class="flex-grow-1 pa-2 mr-2" outlined>
                        <div class="text-overline line-height-1">VENTA</div>
                        <div class="text-button font-weight-bold line-height-1">
                            {{ reporte.venta | currency(reporte.divisa_code) }}
                        </div>
                    </v-card>
    
                    <v-card elevation="0" class="flex-grow-1 pa-2 mr-2" outlined>
                        <div class="text-overline line-height-1">COMISIÓN</div>
                        <div class="text-button font-weight-bold line-height-1">
                            {{ reporte.comision | currency(reporte.divisa_code) }}
                        </div>
                    </v-card>
    
                    <v-card elevation="0" class="flex-grow-1 pa-2 mr-2" outlined>
                        <div class="text-overline line-height-1">PREMIO</div>
                        <div class="text-button font-weight-bold line-height-1">
                            {{ reporte.premio | currency(reporte.divisa_code) }}
                        </div>
                    </v-card>
    
                    <v-card elevation="0" class="flex-grow-1 pa-2" outlined>
                        <div class="text-overline line-height-1">TOTAL</div>
                        <div class="text-button font-weight-bold line-height-1">
                            {{ reporte.total | currency(reporte.divisa_code) }}
                        </div>
                    </v-card>
                </div>
            </v-card>
        </template>
    </div>
</template>

<script>
import ReporteService from '@/services/institution/ReporteService';

export default {
    components: {},
    props: {
        params: {
            defaults: function() {
                return {};
            },
        },
    },
    data: function() { 
        return {
            list: [],
            fetching: false,
        }
    },
    computed: {
        computedList: function () {
            return this.list.length ? this.list : [{
                venta: 0,
                comision: 0,
                premio: 0,
                total: 0,
            }];
        }
    },
    methods: {
        fetch: async function () {
            this.fetching = true;
            this.list = [];

            const params = { ... this.params };

            try {
                const {
                    list
                } = await ReporteService.VentaPorDivisa(params);

                this.list = list;
            } catch (error) {
                // ERROR
            }

            this.fetching = false;
        }
    },
    watch: {
        params: function () {
            this.fetch();
        }
    },
    mounted: function () {
        this.fetch();
    }
}
</script>
<style>

</style>